export default String.raw`
.textElement {
    padding: 32px 5%;
}

.products-page {
    .textElement {
        margin-bottom: 15px;
    }
}
`